import Vue from "vue"
import VueRouter from "vue-router"
import HomeView from "../views/HomeView.vue"
import Document from "../views/document.vue"
import Foodsafety from "../views/foodSafety.vue"
import Marketmanagement from "../views/marketManagement.vue"
import Complaint from "../views/complaint.vue"


Vue.use(VueRouter)

export const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/document",
    name: "Document",
    component: Document,
  },
  {
    path: "/foodsafety",
    name: "Foodsafety",
    component: Foodsafety,
  },
  {
    path: "/marketManagement",
    name: "Marketmanagement",
    component: Marketmanagement,
  },
  {
    path: "/complaint",
    name: "Complaint",
    component: Complaint,
  },

  { path: "*", redirect: "/", hidden: true },
]
const router = new VueRouter({
  routes,
})

export default router
